import { render, staticRenderFns } from "./Professionalization.vue?vue&type=template&id=732a95f1&scoped=true"
import script from "./Professionalization.vue?vue&type=script&lang=js"
export * from "./Professionalization.vue?vue&type=script&lang=js"
import style0 from "./Professionalization.vue?vue&type=style&index=0&id=732a95f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a95f1",
  null
  
)

export default component.exports